import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface QueryParams {
  dateFrom: string;
  dateTo: string;
  vendorFrom?: string;
  vendorTo?: string;
}

export interface ReconciliationItem {
  doc_type: string;  // "receipt" | "return" | "payment"
  doc_no: string;
  doc_date: string;
  amount: number;
}

export interface VendorSummary {
  vendor_code: string;
  vendor_name: string;
  currency: string;
  receipt_total: number;
  return_total: number;
  payment_total: number;
  balance: number;
  items: ReconciliationItem[];
}

export interface ReportSummary {
  total_receipt: number;
  total_return: number;
  total_payment: number;
  total_balance: number;
  vendor_count: number;
}

export interface QueryResponse {
  data: VendorSummary[];
  summary: ReportSummary;
  message?: string;
}

// ============================================================
// API Client
// ============================================================

export const pwd310Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pwd310/query', params);
    return res.data;
  },

  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pwd310/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
